const home = resolve => require(['@/pages/home'], resolve);

export default [{
    path: "/",
    redirect: "/home"
  },
  /*******************个人工作台**************/
  {
    path: "/home",
    name: "个人工作台",
    component: home
  }
]
